
(function configMenuModule() {

    'use strict';

    angular.module("ConfigMenu", ['NavMenu'])
        .run([
            'navMenu', 'authExtend', function configMenuRun(navMenu, auth) {

                function mnuProfileItems(userOu) {

                    var items = [
                        {
                            condition: function () {
                                return (auth.isLogged() && (userOu != null && userOu.length > 0 ? !userOu[0].isLDAP : true));
                            },
                            text: 'ChangePassword',
                            state: 'change-password'
                        },
                        {
                            condition: function () {
                                return (auth.isInRole('USERIMPERSONATION WRITE'));
                            },
                            text: 'UserImpersonation',
                            state: 'user-impersonation'
                        },
                        {
                            condition: function () {
                                return (auth.isLogged());
                            },
                            text: 'Profile',
                            state: 'profile-detail'
                        },
                        {
                            condition: function () {
                                return (auth.isInRole('DOCUMENT SIGN') || auth.isInRole('DOCUMENTVERSION SIGN'));
                            },
                            text: 'AddCertificate',
                            state: 'user-certificates'
                        }
                    ];

                    if (userOu != null) {
                        userOu.forEach(function (user) {
                            if (user.organizationalUnit.name != auth.getOrganizationName()) {
                                if (user.enabled) {
                                    var item = {
                                        condition: function () {
                                            return (auth.isLogged());
                                        },
                                        text: user.organizationalUnit.name,
                                        state: 'inicio-changeuser',
                                        keyview: user.userId
                                    };
                                    items.push(item);
                                } else {
                                    var item = {
                                        condition: function () {
                                            return (auth.isLogged());
                                        },
                                        text: user.organizationalUnit.name + "( Deshabilitado )"
                                    };
                                    items.push(item);
                                }
                            }
                        });
                    }

                    return items;
                }

                function menu() {
                    navMenu.clear();

                    if (auth.isLogged()) {
                        navMenu.setUserMenuItems(mnuProfileItems(auth.getUsers()));
                    } else {
                        navMenu.setUserMenuItems(mnuProfileItems(null));
                    }

                    navMenu.addItem({
                        condition: function () {
                            return (auth.isLogged());
                        },
                        icon: 'far fa-home',
                        tooltip: 'MenuHome',
                        text: 'MenuHome',
                        state: 'inicio',
                        order: 0
                    }, -1);
                    navMenu.addItem({
                        condition: function () {
                            return (auth.isInRole('AUDIT READ')
                                || auth.isInRole('ROLE READ')
                                || auth.isInRole('ROLE WRITE')
                                || auth.isInRole('METADATA READ')
                                || auth.isInRole('METADATA WRITE')
                                || auth.isInRole('DOCUMENTTYPE READ')
                                || auth.isInRole('DOCUMENTTYPE WRITE')
                                || auth.isInRole('ORGANIZATIONALUNIT READ')
                                || auth.isInRole('ORGANIZATIONALUNIT WRITE')
                                || auth.isInRole('CONTAINERTYPE READ')
                                || auth.isInRole('CONTAINERTYPE WRITE')
                                || auth.isInRole('USER READ')
                                || auth.isInRole('USER WRITE')
                                || auth.isInRole('MIGRATOR READ')
                                || auth.isInRole('MIGRATOR WRITE')
                                || auth.isInRole('NOTIFICATION WRITE')
                                || auth.isInRole('NOTIFICATION READ')
                                || auth.isInRole('AUTH NOTIFICATION WRITE')
                                || auth.isInRole('AUTH NOTIFICATION READ')
                            );
                        },
                        icon: 'far fa-cogs',
                        tooltip: 'MenuAdmin',
                        text: 'MenuAdmin',
                        order: 5,
                        items: [
                            {
                                condition: function () {
                                    return (auth.isInRole('AUDIT READ'));
                                },
                                icon: 'far fa-archive',
                                tooltip: 'MenuAudit',
                                text: 'MenuAudit',
                                state: 'audit-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('MIGRATOR READ') || auth.isInRole('MIGRATOR WRITE'));
                                },
                                icon: 'far fa-cog',
                                tooltip: 'MenuMigrator',
                                text: 'MenuMigrator',
                                state: 'migrator-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('ROLE READ') || auth.isInRole('ROLE WRITE'));
                                },
                                icon: 'far fa-users',
                                tooltip: 'MenuRole',
                                text: 'MenuRole',
                                state: 'role-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('METADATA READ') || auth.isInRole('METADATA WRITE'));
                                },
                                icon: 'far fa-cog',
                                tooltip: 'MenuMetadata',
                                text: 'MenuMetadata',
                                state: 'metadata-find-menu'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('DOCUMENTTYPE READ') || auth.isInRole('DOCUMENTTYPE WRITE'));
                                },
                                icon: 'far fa-cog',
                                tooltip: 'MenuDocumentType',
                                text: 'MenuDocumentType',
                                state: 'document-type-find-menu'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('USER READ') || auth.isInRole('USER WRITE'));
                                },
                                icon: 'far fa-user',
                                tooltip: 'MenuUser',
                                text: 'MenuUser',
                                state: 'user-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('ORGANIZATIONALUNIT READ') || auth.isInRole('ORGANIZATIONALUNIT WRITE'));
                                },
                                icon: 'far fa-building',
                                tooltip: 'MenuOrganizationalUnit',
                                text: 'MenuOrganizationalUnit',
                                state: 'organizational-unit-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('CONTAINERTYPE READ'));
                                },
                                icon: 'far fa-cog',
                                tooltip: 'MenuContainerType',
                                text: 'MenuContainerType',
                                state: 'container-type-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('BACKGROUND TASK READ'));
                                },
                                icon: 'far fa-cog',
                                tooltip: 'MenuProcesos',
                                text: 'MenuProcesos',
                                state: 'background-task-home'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('NOTIFICATION READ') || auth.isInRole('NOTIFICATION WRITE'));
                                },
                                icon: 'far fa-newspaper',
                                tooltip: 'MenuNotification',
                                text: 'MenuNotification',
                                state: 'notification-config-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('AUTH NOTIFICATION READ') || auth.isInRole('AUTH NOTIFICATION WRITE'));
                                },
                                icon: 'far fa-balance-scale',
                                tooltip: 'MenuAuthNotification',
                                text: 'MenuAuthNotification',
                                state: 'auth-notification-config-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('APPLICATION INFORMATION'));
                                },
                                icon: 'far fa-info-circle',
                                tooltip: 'MenuStatus',
                                text: 'MenuStatus',
                                state: 'status-info'
                            }
                        ]
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return (auth.getOrganizationId() !== '')
                                && (auth.isInRole('DOCUMENT WRITE')
                                    || auth.isInRole('DOCUMENTVERSIONED WRITE')
                                    || auth.isInRole('DOCUMENTCONTAINER WRITE')
                                    || auth.isInRole('CALENDAR READ')
                                    || auth.isInRole('WORKFLOW READ')
                                );
                        },
                        icon: 'far fa-eye',
                        tooltip: 'MenuMyTasks',
                        text: 'MenuMyTasks',
                        order: 6,
                        items: [
                            {
                                condition: function () {
                                    return (auth.isInRole('DOCUMENT WRITE') || auth.isInRole('DOCUMENTVERSIONED WRITE'));
                                },
                                icon: 'far fa-file-edit',
                                tooltip: 'MenuDocument',
                                text: 'MenuDocument',
                                state: 'document-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('DOCUMENTCONTAINER WRITE'));
                                },
                                icon: 'far fa-folder-open',
                                tooltip: 'MenuDocumentContainer',
                                text: 'MenuDocumentContainer',
                                state: 'document-container-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('CALENDAR READ'));
                                },
                                icon: 'far fa-calendar',
                                tooltip: 'MenuCalendar',
                                text: 'MenuCalendar',
                                state: 'calendar-view'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('WORKFLOW READ'));
                                },
                                icon: 'far fa-inbox',
                                tooltip: 'WorkFlowTitle',
                                text: 'WorkFlowTitle',
                                state: 'workflow-find'
                            }
                        ]
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return (auth.getOrganizationId() !== '')
                                && (auth.isInRole('DOCUMENT READ')
                                    || auth.isInRole('DOCUMENTCONTAINER READ'));
                        },
                        icon: 'far fa-search',
                        tooltip: 'MenuSearch',
                        text: 'MenuSearch',
                        order: 7,
                        items: [
                            {
                                condition: function () {
                                    return (auth.isInRole('DOCUMENT READ'));
                                },
                                icon: 'far fa-search',
                                tooltip: 'MenuDocumentAdvanced',
                                text: 'MenuDocumentAdvanced',
                                state: 'document-advanced-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('DOCUMENTCONTAINER READ'));
                                },
                                icon: 'far fa-search',
                                tooltip: 'MenuDocumentContainerAdvanced',
                                text: 'MenuDocumentContainerAdvanced',
                                state: 'document-container-advanced-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('USER QUERIES'));
                                },
                                icon: 'far fa-bookmark',
                                tooltip: 'MenuMyQueries',
                                text: 'MenuMyQueries',
                                state: 'user-query-find'
                            }
                        ]
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return (
                                    auth.isInRole('IMPORTPROCESS READ')
                                    || auth.isInRole('IMPORTPROCESS WRITE')
                                    || auth.isInRole('IMPORT IMAGES PROCESS READ')
                                    || auth.isInRole('IMPORT IMAGES PROCESS WRITE')
                                );
                        },
                        icon: 'far fa-file-import',
                        tooltip: 'MenuImportActions',
                        text: 'MenuImportActions',
                        order: 8,
                        items: [
                            {
                                condition: function () {
                                    return (auth.isInRole('IMPORTPROCESS READ') || auth.isInRole('IMPORTPROCESS WRITE'));
                                },
                                icon: 'far fa-file-upload',
                                tooltip: 'MenuImportProcess',
                                text: 'MenuImportProcess',
                                state: 'import-process-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('IMPORT IMAGES PROCESS READ') || auth.isInRole('IMPORT IMAGES PROCESS WRITE'));
                                },
                                icon: 'far fa-file-image',
                                tooltip: 'MenuImportImagesProcess',
                                text: 'MenuImportImagesProcess',
                                state: 'import-images-process-find'
                            }
                        ]
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return (auth.getOrganizationId() !== '') && (auth.isInRole('DOCUMENT READ') || auth.isInRole('DOCUMENTCONTAINER READ'));
                        },
                        icon: 'far fa-star',
                        text: 'MenuFavorites',
                        tooltip: 'MenuFavorites',
                        state: 'favorites',
                        order: 1,
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return (auth.getOrganizationId() !== '') && (auth.isInRole('DOCUMENT WRITE') || auth.isInRole('DOCUMENTVERSIONED WRITE'));
                        },
                        icon: 'far fa-file-plus',
                        text: 'MenuBtnAddDocument',
                        tooltip: 'MenuBtnAddDocument',
                        state: 'document-add',
                        order: 2,
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return (auth.getOrganizationId() !== '') && auth.isInRole('DOCUMENTCONTAINER WRITE');
                        },
                        icon: 'far fa-folder',
                        text: 'MenuBtnAddContainer',
                        tooltip: 'MenuBtnAddContainer',
                        state: 'document-container-add',
                        order: 3,
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return auth.isInRole('GO TO CPP');
                        },
                        icon: 'fal fa-exchange',
                        text: 'IrACpp',
                        tooltip: 'IrACpp',
                        order: 4,
                        function: 'createCORSRequest'
                    }, -1);
                }

                auth.onIdentityChanged(function () {

                    menu();
                });

                menu();
            }
        ]);

})();